module.exports = __webpack_public_path__ + "static/media/feature.5ac4b3a2.png";